<template>
  <div>
    <div
      style="display: flex; flex-direction: row; justify-content: space-between; cursor: pointer;"
    >
      <v-img
        height="25"
        width="25"
        contain
        :src="game.game.home_team_small_logo_url"
      ></v-img>
      <!-- <v-icon>mdi-minus</v-icon> -->
      <v-img
        height="25"
        width="25"
        contain
        :src="game.game.away_team_small_logo_url"
      ></v-img>
    </div>
    <div v-if="game.events && !game.loading">
      <div
        class="d-flex justify-space-between px-2 "
        :style="`background-color: ${event_opened(e.event_id) ? 'grey' : ''}`"
        style="cursor: pointer; border-radius: 5px;"
        v-for="e in filteredEvents"
        :key="e.event_id"
        :data-event-id="e.event_id"
        @click="handleEventClick(e)"
      >
        <div style="display: flex; align-items: center;">
          <div>
            {{ e.hitter_name }}
          </div>
        </div>
        <div class="d-flex">
          <div>
            <v-icon size="15" color="red" v-for="(_, i) in e.outs" :key="i + 'outs' + e.event_id">mdi-close</v-icon>
          </div>
          <div style="width: 30px; text-align: right;">
            {{ e.bases_state }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex justify-center">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: ['game', 'index'],
  data: () => ({
    mapped_colors: {
      karkilyonti: 'green',
      palo: 'red',
      haava: 'yellow',
      haava_kt: 'grey',
      takapalo: 'grey',
      vapaa: 'grey',
      takaeteneminen: 'grey'
    }
  }),
  created() {
    this.getEvents()
  },
  computed: {
    ...mapGetters('filter', ['events', 'event_opened', 'filter', 'gameFilteredEvents']),
    filteredEvents() {
      // Remove objects with duplicate event_id, keep only the first occurrence
      const seen = new Set();
      return this.gameFilteredEvents(this.game.events).filter(e => {
        if (seen.has(e.event_id)) return false;
        seen.add(e.event_id);
        return true;
      });
    }
  },
  methods: {
    ...mapActions('filter', [
      'getGameEvents',
      'openEvent'
    ]),
    ...mapMutations('filter', [
      'SET_USER_OPENED_EVENT',
      'SET_LOADING'
    ]),
    getEvents() {
      this.getGameEvents({ game_id: this.game.game.id })
        .then((e) => {
          if(this.index === 0 && e && e.length) {
            this.handleEventClick(this.filteredEvents[0])
          }
        })
    },
    handleEventClick(e) {
      console.log('Event clicked:', {
        event_id: e.event_id,
        id: e.id,
        openedEvent_id: this.$store.state.filter.openedEvent?.event_id,
        openedEvent_id_alt: this.$store.state.filter.openedEvent?.id
      })
      this.SET_USER_OPENED_EVENT(true)
      this.openEvent(e)
    }
  }
}
</script>